import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'

const ReactMarkdownSt = styled(ReactMarkdown)`
  font-family: Manrope;
`

export const Markdown = ({ children, ...rest }: { children: string}) => {
  return <ReactMarkdownSt { ...rest}>{children}</ReactMarkdownSt>
}